<script>
const DEFAULT_LAYOUT = 'LayoutDashboard';

// Cache async layout components so the same layout keeps the same component
// reference across route changes (a new reference would remount the layout).
const layoutComponents = {};
const getLayoutComponent = (layoutName) => {
  if (!layoutComponents[layoutName]) {
    layoutComponents[layoutName] = () => import(`@/components/layouts/${layoutName}.vue`);
  }
  return layoutComponents[layoutName];
};

export default {
  data() {
    return {
      isRouterReady: false,
      layoutEvents: null,
    };
  },

  computed: {
    /**
     * The layout comes from the route (closest matched record with `meta.layout`),
     * so it is known before the page mounts. Previously each page set it from
     * <LayoutHandler> after mounting, which made every page mount twice.
     */
    layoutName() {
      const record = [...this.$route.matched].reverse().find((r) => r.meta?.layout);
      return record?.meta.layout || DEFAULT_LAYOUT;
    },
    layout() {
      return getLayoutComponent(this.layoutName);
    },
  },

  created() {
    // Wait for the initial navigation so the first render already uses the right layout.
    const setReady = () => { this.isRouterReady = true; };
    this.$router.onReady(setReady, setReady);
  },

  methods: {
    changeLayout(layoutName) {
      // Layout is driven by route meta; this only flags pages whose <LayoutHandler> disagrees.
      if (process.env.NODE_ENV !== 'production' && layoutName !== this.layoutName) {
        console.warn(
          `[LayoutProvider] Route "${this.$route.name}" uses ${this.layoutName} but its page declares ${layoutName}. Set meta.layout on the route.`
        );
      }
    },
    handleEvents(event) {
      this.layoutEvents = event;
    }
  },

  provide() {
    const layoutProvider = {};
    layoutProvider.changeLayout = this.changeLayout;
    layoutProvider.handleEvents = this.handleEvents;
    return { layoutProvider };
  },
}
</script>

<template>
  <component v-if="isRouterReady" :is="layout" v-on="layoutEvents">
    <slot></slot>
  </component>
</template>


<style lang="scss" scoped>

</style>
